import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppRoute,
  NavigationOptions,
  RedirectionState,
  UseNavigationReturn,
} from '../types';
import { NAVIGATION_DELAY_MS } from '../constants';

export const useNavigation = (): UseNavigationReturn => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [redirectionState, setRedirectionState] = useState<RedirectionState>({
    shouldRedirect: false,
    targetRoute: null,
    reason: null,
  });

  const navigateToRoute = useCallback(
    (route: AppRoute, options: NavigationOptions = {}) => {
      const { replace = false, state } = options;

      setIsRedirecting(true);

      setTimeout(() => {
        navigate(route, { replace, state });
        setIsRedirecting(false);
      }, NAVIGATION_DELAY_MS);
    },
    [navigate]
  );

  const navigateToHome = useCallback(() => {
    navigateToRoute('/', { replace: true });
  }, [navigateToRoute]);

  useEffect(() => {
    if (redirectionState.shouldRedirect && redirectionState.targetRoute) {
      navigateToRoute(redirectionState.targetRoute, { replace: true });

      setRedirectionState({
        shouldRedirect: false,
        targetRoute: null,
        reason: null,
      });
    }
  }, [redirectionState, navigateToRoute]);

  return {
    isRedirecting,
    redirectionState,
    navigateToRoute,
    navigateToHome,
  };
};

export default useNavigation;
